import Immutable from "immutable";
import { combineReducers } from "redux";
import { RECEIVE, REQUEST } from "./constants";
import {
  CREATE as CREATE_VALUE,
  BULK_CREATE as BULK_CREATE_VALUE
} from "redux/modules/modules/values/constants";
import { ERROR } from "redux/modules/errors/constants";
import settings from "./settings/reducer";

const updateValue = (
  state,
  immutableState,
  { moduleId, recordId, fieldId, value }
) => {
  if (!state[moduleId]) return immutableState;

  const indexOfRecord = state[moduleId].records.findIndex(
    r => r.id === recordId
  );

  if (indexOfRecord === -1) {
    return immutableState;
  }

  return immutableState.setIn(
    [moduleId, "records", indexOfRecord, "values", fieldId],
    value
  );
};

const updateValues = (state, immutableState, moduleId, values) =>
  values.reduce(
    (map, { recordId, fieldId, value }) =>
      updateValue(state, map, {
        moduleId,
        recordId,
        fieldId,
        value
      }),
    immutableState
  );

const records = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE:
      return Immutable.fromJS(state)
        .setIn([action.payload.moduleId], action.payload.records)
        .toJS();

    case CREATE_VALUE: {
      return updateValue(state, Immutable.fromJS(state), {
        moduleId: action.payload.moduleId,
        recordId: action.payload.recordId,
        fieldId: action.payload.fieldId,
        value: action.payload.value
      }).toJS();
    }

    case BULK_CREATE_VALUE: {
      return updateValues(
        state,
        Immutable.fromJS(state),
        action.payload.moduleId,
        action.payload.values
      ).toJS();
    }

    default:
      return state;
  }
};

const fetching = (state = {}, action) => {
  switch (action.type) {
    case REQUEST:
      return Immutable.fromJS(state)
        .setIn([action.payload.moduleId], true)
        .toJS();
    case RECEIVE:
      return Immutable.fromJS(state)
        .setIn([action.payload.moduleId], false)
        .toJS();
    case ERROR:
      return {};
    default:
      return state;
  }
};

export default combineReducers({
  records,
  settings,
  fetching
});
